'use client';

import { useRouter } from '@/navigation';
import React, { useState } from 'react';
import { useLocale } from 'next-intl';

const SearchIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.66665 3.33398C12.8883 3.33398 15.5 5.94566 15.5 9.16732C15.5 10.4776 15.068 11.687 14.3386 12.6608L16.9226 15.2448C17.248 15.5702 17.248 16.0978 16.9226 16.4233C16.5971 16.7487 16.0695 16.7487 15.7441 16.4233L13.1601 13.8393C12.1863 14.5687 10.9769 15.0007 9.66665 15.0007C6.44499 15.0007 3.83331 12.389 3.83331 9.16732C3.83331 5.94566 6.44499 3.33398 9.66665 3.33398ZM9.66665 13.334C11.9678 13.334 13.8333 11.4685 13.8333 9.16732C13.8333 6.86613 11.9678 5.00065 9.66665 5.00065C7.36546 5.00065 5.49998 6.86613 5.49998 9.16732C5.49998 11.4685 7.36546 13.334 9.66665 13.334Z"
      fill="#676779"
    />
  </svg>
);

export const SearchInput = ({ placeHolder }: { placeHolder: string }) => {
  const locale = useLocale();
  const [query, setQuery] = useState('');
  const router = useRouter();

  const onSearch = () => {
    const trimmedQuery = query.trim();
    if (trimmedQuery)
      router.push(`/faq/search?q=${trimmedQuery}`, { locale: locale });
  };

  return (
    <div className="flex h-[60px] items-center rounded-[8px] border border-solid border-[#BEC2CC] bg-white px-3 shadow-[0_5px_4px_-4px_rgba(0,0,0,0.02),0_1px_2px_0_rgba(0,0,0,0.06)] md:h-[80px] md:p-5">
      {/* Desktop: search icon on left */}
      <button
        type="button"
        className="hidden shrink-0 items-center justify-center p-[5px] md:flex md:size-[40px]"
        onClick={onSearch}
        aria-label="Search"
      >
        <SearchIcon className="size-[30px]" />
      </button>
      <input
        className="min-w-0 flex-1 bg-transparent text-[14px] leading-[22px] tracking-[-0.128px] text-3b-text-primary outline-none placeholder:text-[#BEC2CC] md:text-[18px] md:font-medium md:leading-[28px] md:tracking-[-0.256px]"
        placeholder={placeHolder}
        onKeyUp={e => {
          if (e.key === 'Enter') onSearch();
        }}
        onChange={e => setQuery(e.target.value)}
        value={query}
      />
      {/* Mobile: search icon on right */}
      <button
        type="button"
        className="flex size-[32px] shrink-0 items-center justify-center p-[6px] md:hidden"
        onClick={onSearch}
        aria-label="Search"
      >
        <SearchIcon className="size-[24px]" />
      </button>
    </div>
  );
};
